import { jsxs, jsx } from 'react/jsx-runtime';
import { faMobile, faArrowLeftLong, faDisplay } from '@optimizely/pro-light-svg-icons';
import { faMobile as faMobile$1, faArrowLeftLong as faArrowLeftLong$1, faDisplay as faDisplay$1 } from '@optimizely/pro-regular-svg-icons';
import { LayeredIcons, Icon, OutlinedIcon } from './icon.js';

const AppPushIcon = ({
  className,
  color,
  size,
  title,
  weight = "",
  ...props
}) => {
  return /* @__PURE__ */ jsxs(LayeredIcons, { className, size, title, ...props, children: [
    /* @__PURE__ */ jsx(
      Icon,
      {
        color,
        icon: weight === "thin" ? faMobile : faMobile$1,
        size
      }
    ),
    /* @__PURE__ */ jsx(
      OutlinedIcon,
      {
        color,
        icon: weight === "thin" ? faArrowLeftLong : faArrowLeftLong$1,
        size,
        transform: "shrink-4 right-4 up-2"
      }
    )
  ] });
};
const WebPushIcon = ({
  className,
  color,
  size,
  title,
  weight,
  ...props
}) => {
  return /* @__PURE__ */ jsxs(LayeredIcons, { className, size, title, ...props, children: [
    /* @__PURE__ */ jsx(
      Icon,
      {
        color,
        icon: weight === "thin" ? faDisplay : faDisplay$1,
        size
      }
    ),
    /* @__PURE__ */ jsx(
      OutlinedIcon,
      {
        color,
        icon: weight === "thin" ? faArrowLeftLong : faArrowLeftLong$1,
        size,
        transform: "shrink-5.5 right-5 up-1.5"
      }
    )
  ] });
};

export { AppPushIcon, WebPushIcon };
